import { render, staticRenderFns } from "./GraphDetail32.vue?vue&type=template&id=9d2b13e8&scoped=true"
import script from "./GraphDetail32.vue?vue&type=script&lang=js"
export * from "./GraphDetail32.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2b13e8",
  null
  
)

export default component.exports